import React, { Component } from 'react';
import fetch from 'cross-fetch';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import NavBar from './NavBar.jsx';
import TextField from '../bits/TextField.jsx';

class DeviceIdForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
    nextDisabled: true,
  }

  onSubmit = () => {
    const { onNext } = this.props;
    const { deviceEmei } = this.props.values;

    this.setState({
      isLoading: true,
    });

    fetch(`/devices/find?emei=${deviceEmei}`, {
      credentials: 'include',
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        throw new Error(response.status === 404 ? 'device_id_form.error_imei_unknown' : 'device_id_form.error_unknown');
      })
      .then((data) => {
        if (data.claimed) {
          throw new Error('device_id_form.error_imei_claimed');
        } else if (data.expired) {
          throw new Error('device_id_form.error_imei_expired');
        } else {
          onNext({
            deviceUserGuideUrl: data.userGuideUrl,
            deviceIsPrepaid: data.isPrepaid,
            prepaidDurationDays: data.prepaidDurationDays,
            deviceModel: data.model,
            vineEnabled: data.vineEnabled === true,
            isAmazonReviewer: false,
            validatedPromoCode: '',
          });
        }
      })
      .catch((error) => {
        this.setState({
          errorCode: error.message,
          isLoading: false,
        });
      });
  }

  nextDisabled = () => (this.props.values.deviceEmei.length === 0);

  render() {
    const { values, handleChange, t } = this.props;

    return (
      <div>
        <h2>{t('device_id_form.title')}</h2>
        <div className="form-group">

          <TextField
              id="inputDeviceImei"
              inputProps={{
                type: 'text',
                pattern: '\\d*',
              }}
              label={t('device_id_form.input_label')}
              value={values.deviceEmei}
              onChange={handleChange('deviceEmei')}
              fullWidth
              margin="normal"
              error={Boolean(this.state.errorCode)}
              helperText={t(this.state.errorCode)}
            />
          <p className="form-text text-muted">
            {t('device_id_form.description')}
          </p>
        </div>
        <NavBar
          isLoading={this.state.isLoading}
          nextDisabled={this.nextDisabled()}
          onNext={this.onSubmit} />
      </div>
    );
  }
}

DeviceIdForm.propTypes = {
  onNext: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object,
};

export default withTranslation('activation_wizard')(DeviceIdForm);
